import { Grid, Typography } from '@material-ui/core';
import Carousel from 'nuka-carousel';
import Image from '../components/Image';
import { images } from 'src/utils/constants';
function EmployeeViewRequest({ data }) {
  return (
    <div style={{ padding: '12px' }}>
      <Grid
        style={{
          marginTop: '20px',
          marginBottom: '20px',
          overflow: 'hidden',
          borderRadius: '10px',
          padding: '10px',
          boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)'
        }}
      >
        <Typography variant="h4">Doctor Comments</Typography>
        <Typography variant="body1" gutterBottom>
          {data?.dr_comments ?? 'NA'}
        </Typography>
      </Grid>
      <Grid
        style={{
          marginTop: '20px',
          marginBottom: '20px',
          overflow: 'hidden',
          borderRadius: '10px',
          padding: '10px',
          boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)'
        }}
      >
        <Typography variant="h4">Admin Comments</Typography>
        <Typography variant="body1" gutterBottom>
          {data?.admin_comments ?? 'NA'}
        </Typography>
      </Grid>
      {Object.entries(images).map((arr) => {
        return (
          <Grid
            key={arr[0]}
            container
            direction="column"
            style={{
              marginTop: '20px',
              padding: '10px'
            }}
          >
            <Typography variant="h4">{arr[1]}</Typography>
            {data[arr[0]].length === 0 ? (
              <Typography>NA </Typography>
            ) : (
              <Carousel height="60vh">
                {data[arr[0]].map((imgKey) => {
                  return <Image key={imgKey} imgKey={imgKey} />;
                })}
              </Carousel>
            )}
          </Grid>
        );
      })}
      <Grid
        direction="column"
        container
        style={{
          marginTop: '20px',
          overflow: 'hidden',
          borderRadius: '10px',
          padding: '10px',
          boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)'
        }}
      >
        <Typography variant="h4">Notes</Typography>
        <Typography variant="body1" gutterBottom>
          {data?.notes || 'NA'}
        </Typography>
      </Grid>
    </div>
  );
}

export default EmployeeViewRequest;
